<template>
  <div class="wrapper">
    <div>
    <CButton color="info" @click="openModal"><b>Add New Roles</b></CButton>
    <CRow class="mt-3">
      <div>  
      </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @assign_user="handleAssign_User"
                            @assign_permission="handleAssign_Permission"
                            @edit="handleEdit"
                            @destroy="handleDestroy"

                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
      <rolemodal></rolemodal>
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_role.vue'
import axios from 'axios'

import roles from '@/services/roles'
import rolemodal from './rolemodal.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

const token = localStorage.getItem('token');

export default {
  name: 'role',
  components: { rolemodal, alertmodal, Datatable },
  data(){
    return{
      form:{
        name:'',
      },
      updateSubmit: false,
      largeModal:false,
      datas:[], 

      fields: [
          {key: 'name', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      //is_active: 1,
    }
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

   },
   
  methods: {
    openModal: function () {
      var params = {title: 'Add New Role', mode:'create'}
      EventBus.$emit('OPEN_MODAL_ROLE', params)
    },
    

    assignuser(id){
      this.$router.push({name:'Assign User',query: {id:id} }) 
    },
    assignpermission(id){
      this.$router.push({name:'Assign Permission',query: {id:id} }) 
    },

    openModalEdit(id){
        var params = {title: 'Edit Role', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_ROLE', params)
    },

    delete(id){
      if(confirm("Do you really want to delete?")){
        roles.deleteRole(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      roles.getRolesDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleAssign_User(val) {
        this.assignuser(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleAssign_Permission(val) {
        this.assignpermission(val)       
    },
    handleDestroy(val) {
        this.delete(val)       
    },

  }
}
</script>